<template src="./Navigation.html"></template>
<style src="./Navigation.scss" lang="scss"></style>

<script>
	import Burger from '@/components/Burger/Burger';

	export default {
		name: 'HpNavigation',
		components: {
			'hp-burger': Burger
		},
		data() {
			return {
				menuReference: '',
				navElementsReference: '',
				moreMenuReference: '',
				moreMenuItem: {},
				fullMenu: [],
				visibleMenu: [],
				moreMenu: [],
				// remove for production
				publicPath: './'
			};
		},
		methods: {
			initializeMenuPoints() {
				this.menuReference = document.querySelector('[data-component="navigation"] > ul');
				this.navElementsReference = document.querySelectorAll('[data-component="navigation"] > ul > li:not([data-more])');
				this.moreMenuReference = document.querySelector('[data-component="navigation"] > ul > [data-more] ul');
				this.moreMenuItem = {
					reference: document.querySelector('[data-component="navigation"] > ul > [data-more]'),
					width: document.querySelector('[data-component="navigation"] > ul > [data-more]').clientWidth
				};

				for (let navElementsIndex = 0; navElementsIndex < this.navElementsReference.length; navElementsIndex++) {
					const itemToPush = {
						reference: this.navElementsReference[navElementsIndex],
						width: this.navElementsReference[navElementsIndex].clientWidth
					};
					this.fullMenu.push(itemToPush);
				}

				this.makeMoreMenu();
			},
			makeMoreMenu() {
				this.visibleMenu = [];
				this.moreMenu = [];

				// clear menu to build new
				while (this.menuReference.firstChild) {
					this.menuReference.removeChild(this.menuReference.firstChild);
				}

				const menuGridGap = parseInt(
					getComputedStyle(this.menuReference)
						.getPropertyValue('--grid-gap')
						.replace('px', '')
						.trim()
				);
				const menuWidth = parseInt(
					getComputedStyle(this.menuReference)
						.getPropertyValue('--ul-max-width')
						.replace('px', '')
						.trim()
				);

				let navwidth = 0;
				for (let i = 0; i < this.fullMenu.length; i++) {
					// also add the gap of grid, but 1 less than elements
					if (i !== 0) {
						navwidth += menuGridGap;
					}
					navwidth += this.fullMenu[i].width;
				}

				const moreItemWidth = this.moreMenuItem.width;
				let availablespace = menuWidth - moreItemWidth;

				if (navwidth > availablespace) {
					let currentUsedSpace = 0;
					this.fullMenu.forEach((item, index) => {
						currentUsedSpace += item.width;
						if (index !== 0) {
							currentUsedSpace += menuGridGap;
						}
						if (currentUsedSpace + this.moreMenuItem.width < availablespace) {
							this.visibleMenu.push(item);
						} else {
							this.moreMenu.push(item);
						}
					});
				}

				this.fullMenu.forEach((item) => {
					this.menuReference.append(item.reference);
				});

				this.moreMenu.forEach((item) => {
					this.moreMenuReference.prepend(item.reference);
				});

				if (this.moreMenu.length > 0) {
					this.menuReference.append(this.moreMenuItem.reference);
				}
			}
		},
		mounted() {
			document.addEventListener(
				'colCountChanged',
				(event) => {
					if (event.detail.colCount > 1) {
						this.makeMoreMenu();
					}
				},
				false
			);
			this.initializeMenuPoints();
		}
	};
</script>
